/**
 * Neutralizes nested image/button links when a column-level link is set,
 * so the overlay is the only keyboard and screen-reader target.
 */
if (!customElements.get('multi-column-column')) {
  class MultiColumnColumn extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-has-link')) return;

      this.#disableNestedLinks();
    }

    #disableNestedLinks() {
      for (const link of this.querySelectorAll('a[href]')) {
        if (link.classList.contains('mcs-column__link')) continue;

        link.removeAttribute('href');
        link.removeAttribute('aria-label');
        link.setAttribute('role', 'presentation');
        link.tabIndex = -1;
      }
    }
  }

  customElements.define('multi-column-column', MultiColumnColumn);
}
